// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Baidu-Map[data-v-134a5c8c] {\n  width: auto;\n}\n.Baidu-Map .Plan-Map[data-v-134a5c8c] {\n    width: auto;\n}\n", ""]);
// Exports
module.exports = exports;
